var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _circle2, _circle3, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15 110c8.284 0 15-6.716 15-15v-65h65c8.284 0 15-6.716 15-15s-6.716-15-15-15h-80c-8.284 0-15 6.716-15 15v80c0 8.284 6.716 15 15 15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m497 0h-80c-8.284 0-15 6.716-15 15s6.716 15 15 15h65v65c0 8.284 6.716 15 15 15s15-6.716 15-15v-80c0-8.284-6.716-15-15-15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m95 482h-65v-65c0-8.284-6.716-15-15-15s-15 6.716-15 15v80c0 8.284 6.716 15 15 15h80c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m497 402c-8.284 0-15 6.716-15 15v65h-65c-8.284 0-15 6.716-15 15s6.716 15 15 15h80c8.284 0 15-6.716 15-15v-80c0-8.284-6.716-15-15-15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m316 211h120c8.284 0 15-6.716 15-15v-120c0-8.284-6.716-15-15-15h-120c-8.284 0-15 6.716-15 15v120c0 8.284 6.716 15 15 15zm15-120h90v90h-90z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m196 301h-120c-8.284 0-15 6.716-15 15v120c0 8.284 6.716 15 15 15h120c8.284 0 15-6.716 15-15v-120c0-8.284-6.716-15-15-15zm-15 120h-90v-90h90z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m451 436v-120c0-8.284-6.716-15-15-15s-15 6.716-15 15v105h-105c-8.284 0-15 6.716-15 15s6.716 15 15 15h120c8.284 0 15-6.716 15-15z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m196 61h-120c-8.284 0-15 6.716-15 15v120c0 8.284 6.716 15 15 15h120c8.284 0 15-6.716 15-15v-120c0-8.284-6.716-15-15-15zm-15 120h-90v-90h90z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m256 211c8.284 0 15-6.716 15-15v-120c0-8.284-6.716-15-15-15s-15 6.716-15 15v120c0 8.284 6.716 15 15 15z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m361 256c0-8.284-6.716-15-15-15h-90c-8.284 0-15 6.716-15 15v180c0 8.284 6.716 15 15 15s15-6.716 15-15v-165h75c8.284 0 15-6.716 15-15z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m76 271h30c8.284 0 15-6.716 15-15s-6.716-15-15-15h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m361 316v60c0 8.284 6.716 15 15 15s15-6.716 15-15v-60c0-8.284-6.716-15-15-15s-15 6.716-15 15z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m301 316v60c0 8.284 6.716 15 15 15s15-6.716 15-15v-60c0-8.284-6.716-15-15-15s-15 6.716-15 15z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m436 241h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15h30c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 376,
    cy: 136,
    r: 15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 136,
    r: 15
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 376,
    r: 15
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m196 241h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15h30c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.a273b7b8.svg";
export { ForwardRef as ReactComponent };